<div class="title" [innerHTML]="'confirmationSendDialog_Data1' | i18n"></div>
<div class="description" [innerHTML]="'confirmationSendDialog_Data2' | i18n: translationModes.INSERT_VALUE : email"></div>
<div class="warning-container">
  <div [innerHTML]="'confirmationSendDialog_Data3' | i18n"></div>
  <div class="warning" [innerHTML]="'confirmationSendDialog_Data4' | i18n" (click)="closeDialog(responses.RESEND)"></div>
  <div [innerHTML]="'confirmationSendDialog_Data5' | i18n"></div>
</div>
<button [innerHTML]="'confirmationSendDialog_Data6' | i18n" (click)="closeDialog()"></button>
